var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "bot-spinner",
    {
      staticClass: "mt-2 bot-center text-right",
      model: {
        value: _vm.spinner,
        callback: function ($$v) {
          _vm.spinner = $$v
        },
        expression: "spinner",
      },
    },
    [
      _c(
        "v-alert",
        {
          staticClass: "mt-2",
          attrs: { dense: "", text: "", type: "warning" },
        },
        [
          _vm._v(
            '\n        Nhất nút "Xác nhận" để chắc chắn rằng bạn muốn đăng xuất!\n    '
          ),
        ]
      ),
      _c("v-btn", { attrs: { color: "primary" }, on: { click: _vm.submit } }, [
        _vm._v("Xác nhận"),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/authen/logout.vue